import axios from 'axios'

const API_URLS = process.env.REACT_APP_API_URLS

export interface Filter {
  field: string | null
  type: string | null
}

export const postCampaigns = async (datas: any) => {
  const new_obj = {...datas, point: 0, pointType: 'fix'}
  try {
    const response = await axios.post(`${API_URLS}/campaigns`, datas.category === 'rewards' ? new_obj : datas )
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putCampaigns = async (datas: any) => {
  try {
    const response = await axios.put(`${API_URLS}/campaigns/${datas.id}`, datas.form)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const deleteCampaigns = async (id: any) => {
  let url = `${API_URLS}/campaigns/${id}`
  try {
    const response = await axios.delete(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignList = async (search?: string, page?: number, filter?: Filter) => {
  let url = `${API_URLS}/campaigns/list?populate=*&`
  if (page) url += `pagination[pageSize]=5&pagination[page]=${page}&`
  if (search) url += `_q=${search}&`
  if (filter?.field && filter.type) url += `filters${filter.field}=${filter.type}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getCampaignDetail = async (id?: string) => {
  let url = `${API_URLS}/campaigns/detail/${id}?populate=*`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const getRewards = async (id?: string) => {
  let url = `${API_URLS}/rewards/${id}`
  try {
    const response = await axios.get(url)
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}

export const putStatusCampaigns = async (value: any) => {
  let url = `${API_URLS}/campaigns/change-status/${value.id}`
  try {
    const response = await axios.put(url, {
      status: value.status,
    })
    return Promise.resolve(response.data.data)
  } catch (error) {
    return Promise.reject(error)
  }
}
